import { FileDocumentCheckOutlineIcon } from './FileDocumentCheckOutlineIcon';

/**
 * author: Simran
 * id AC9C336A-83D0-4FB0-B61A-C6AC0FC2A069
 * name file-document-check-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-check-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentTickOutlineIcon = FileDocumentCheckOutlineIcon;
export default FileDocumentTickOutlineIcon